import request from '../request';
import { GUIDED_TOUR_PREFERENCES } from '../../constants/endpoints';
import type { GuidedToursMap } from '@app/utils/guidedTourStorage';

export type GuidedTourPreferencesResponse = {
  tours: GuidedToursMap;
};

export const fetchGuidedTourPreferences =
  async (): Promise<GuidedTourPreferencesResponse> => {
    const { data } = await request({
      method: 'get',
      url: GUIDED_TOUR_PREFERENCES(),
    });
    return data as GuidedTourPreferencesResponse;
  };

export const patchGuidedTourPreference = async ({
  tourId,
  variant,
}: {
  tourId: string;
  variant: string;
}): Promise<GuidedTourPreferencesResponse> => {
  const { data } = await request({
    method: 'patch',
    url: GUIDED_TOUR_PREFERENCES(),
    data: {
      tourId,
      variant,
      completed: true,
    },
  });
  return data as GuidedTourPreferencesResponse;
};
